import React from 'react';
import { MailIcon, GlobeIcon } from 'lucide-react';
export function Footer() {
  return <footer className="w-full border-t border-ink-600 bg-ink-800 py-14" data-id="element-63" data-mp="3gfsnkey6wyo1">
      <div className="mx-auto max-w-readable px-5 sm:px-8" data-id="element-64" data-mp="3gh3swj7aaeh9">
        <p className="font-display text-xl font-extrabold text-cream" data-id="element-65" data-mp="32p5qer82vgu2">
          🧠 AtajoDigital™
        </p>
        <p className="mt-3 max-w-xl text-[15px] leading-relaxed text-cream/65" data-id="element-66" data-mp="36ppk1ktg02bg">
          El sistema de transformación personal N°1 para adultos en Argentina.
          Porque vivir mejor en este país no es suerte. Es un sistema que
          funciona.
        </p>

        <ul className="mt-7 flex flex-wrap gap-x-8 gap-y-3 text-[15px]" data-id="element-67" data-mp="3lf57aqtrlpme">
          <li data-id="element-68" data-mp="3qd6pzana3mxc">
            <a href="mailto:soporteatajodigital@gmail.com" className="flex items-center gap-2 text-cream/75 transition-colors duration-150 ease-out hover:text-leaf" data-id="element-69" data-mp="3qcx86ace0m2q">
              <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-70" data-mp="2eyjolhoo2ssi" />
              soporteatajodigital@gmail.com
            </a>
          </li>
          <li data-id="element-71" data-mp="3l9sin4pzgsoh">
            <a href="https://www.atajodigital.store" className="flex items-center gap-2 text-cream/75 transition-colors duration-150 ease-out hover:text-leaf" data-id="element-72" data-mp="3lbdces4h47la">
              <GlobeIcon className="h-4 w-4" aria-hidden="true" data-id="element-73" data-mp="3v5dh4svufath" />
              www.atajodigital.store
            </a>
          </li>
        </ul>

        <div className="mt-10 flex flex-wrap items-center justify-between gap-3 border-t border-ink-600 pt-6 text-[13px] text-cream/45" data-id="element-74" data-mp="81yvyfozns2e">
          <p data-id="element-75" data-mp="31uqdkpmchqy">© AtajoDigital™ 2026 — Todos los derechos reservados.</p>
          <p className="italic" data-id="element-76" data-mp="hrigdpscntzd">“El próximo domingo puede ser diferente.”</p>
        </div>
      </div>
    </footer>;
}